/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/sub-pages/ProvisioningTasksSubPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ProvisioningTasksSubPageTestIds = {
  cardTitleProvisioningTasksActive: "card-title-provisioning-tasks-active",
  cardTitleProvisioningTasksHistory: "card-title-provisioning-tasks-history",
  colConnProvAccount: "col-conn-prov-account",
  colConnProvAction: "col-conn-prov-action",
  colConnProvCreated: "col-conn-prov-created",
  colConnProvEntitlement: "col-conn-prov-entitlement",
  colConnProvHistAction: "col-conn-prov-hist-action",
  colConnProvHistCompleted: "col-conn-prov-hist-completed",
  colConnProvHistEntitlement: "col-conn-prov-hist-entitlement",
  colConnProvHistIdentity: "col-conn-prov-hist-identity",
  colConnProvHistStatus: "col-conn-prov-hist-status",
  colConnProvIdentity: "col-conn-prov-identity",
  colConnProvRetries: "col-conn-prov-retries",
  colConnProvStatus: "col-conn-prov-status",
  provisioningTasksActiveCard: "provisioning-tasks-active-card",
  provisioningTasksActiveEmpty: "provisioning-tasks-active-empty",
  provisioningTasksActiveLoading: "provisioning-tasks-active-loading",
  provisioningTasksHistoryCard: "provisioning-tasks-history-card",
  provisioningTasksHistoryEmpty: "provisioning-tasks-history-empty",
  provisioningTasksHistoryLoading: "provisioning-tasks-history-loading",
  provisioningTasksViewAll: "provisioning-tasks-view-all",
  provisioningTasksActiveRow: (row_id: string) => `provisioning-tasks-active-row-${row_id}`,
  provisioningTasksActiveRowPrefix: () => "provisioning-tasks-active-row-" as TestIdPrefix,
  provisioningTasksHistoryRow: (row_id: string) => `provisioning-tasks-history-row-${row_id}`,
  provisioningTasksHistoryRowPrefix: () => "provisioning-tasks-history-row-" as TestIdPrefix
} as const;
